// extracted by mini-css-extract-plugin
module.exports = {"button":"TCButton_button__1LkOj"};